import { CSSProperties, useCallback, useMemo, useState } from 'react'
import classNames from 'classnames'

type AvatarVariant = 'bot' | 'shape' | 'initials'

export type AvatarProps = {
    src?: string | null
    name: string
    variant: AvatarVariant
    className?: string
    onClick?: () => void
    style?: CSSProperties
}

export const Avatar = ({ src: sourceSrc, name, variant, className, onClick, style }: AvatarProps) => {
    const [ignoreSourceSrc, setIgnoreSourceSrc] = useState(false)

    const src = useMemo<string>(() => {
        if (sourceSrc && !ignoreSourceSrc) {
            return sourceSrc
        }

        let path = ''

        switch (variant) {
            case 'bot':
                path = 'bottts-neutral'
                break
            case 'shape':
                path = 'shapes'
                break
            case 'initials':
                path = 'initials'
                break
        }

        return ['https://api.dicebear.com/7.x', path, `svg?seed=${encodeURIComponent(name || '')}`].join('/')
    }, [name, sourceSrc, variant, ignoreSourceSrc])

    const handleErrorLoading = useCallback(() => {
        console.error('Failed to load avatar')
        setIgnoreSourceSrc(true)
    }, [])

    return (
        <img
            style={style}
            className={classNames(className, 'inline-flex max-w-none items-center justify-center object-cover', {
                'cursor-pointer': !!onClick,
            })}
            src={src}
            onError={handleErrorLoading}
            onClick={onClick}
        />
    )
}
